import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Logo from './logo';

class Header extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const { content } = this.props;

        return (
            <div>
                <div className={styles.search_bar}>
                    <Logo content={content} />
                </div>
            </div>
        );
    }
}

export default errorBoundary(Header);
